<template>
  <div style="min-width: 300px !important">
    <v-row>
      <v-col cols="5"> <v-icon>mdi-car</v-icon> </v-col>
      <v-col cols="7"> <b>{{vehicle.plate_number || vehicle.name}}</b> </v-col>
    </v-row>
    <v-row style="margin-top: -5px"> 
      <v-col>{{vehicle.current_loc}}</v-col>
    </v-row>
    <v-row>
      <v-col cols="5"> <b>Time:</b> </v-col>
      <v-col cols="7">{{ trackerTime }}</v-col>
    </v-row>

    <v-row>
      <v-col cols="5"> <b>Status:</b> </v-col>
      <v-col cols="7">
        <span v-if="vehicle.speed==0 && vehicle.engineon">Idling</span>
        <span v-if="vehicle.speed==0 && !vehicle.engineon">Parked</span>
        <span v-if="vehicle.speed > 0">Moving</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="5"> <b>Speed:</b> </v-col>
      <v-col cols="7">
        <v-icon size="20" v-if="vehicle.speed==0">mdi-car-brake-parking</v-icon>
        <v-icon size="20" color="green" v-if="vehicle.speed >0">mdi-car-cruise-control</v-icon>
        {{vehicle.speed}} KPH/h
      </v-col>
    </v-row>

    <v-row v-if="vehicle.odometer">
      <v-col cols="5"> <b>Odometer:</b> </v-col>
      <v-col cols="7">{{vehicle.odometer? parseFloat(vehicle.odometer).toFixed(2) : ''}}</v-col>
    </v-row>  

     <!-- <v-img
                        src="/car.png"
                        v-bind:style="'transform: rotate('+ vehicle.angle +'deg);'"
                        aspect-ratio="1"
                        height="40"
                        width="40"
                      ></v-img>  -->
  </div>
</template>
<style   scoped>
  body{
    font-size: 10px;
    line-height: 12px;
  }
</style>
<script>
import { formatTrackerTime } from "../mixins/kensrin_map";

export default {
  name: "MapPopup",
  props: {
    vehicle: ""
  },
  computed: {
    // Vehicle time is already in the account timezone; only reformat it.
    trackerTime() {
      return formatTrackerTime(this.vehicle && this.vehicle.dt_tracker);
    }
  }
};
</script>